module.exports = __webpack_public_path__ + "img/chr_ts_21_3.fa5ce807.png";